import { Component, Input, OnInit } from '@angular/core';
import { FormViewComponent } from 'src/app/dynamic-forms/form-view/form-view.component';
import { CardView } from 'src/app/interfaces/cardview';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';

@Component({
    selector: 'app-shopee',
    templateUrl: './shopee.component.html',
    styleUrls: ['./shopee.component.scss'],
    standalone: false
})
export class ShopeeComponent implements OnInit {

  constructor() { }

  
  criacaoProduto = FormViewComponent;
  @Input() parentRow:CardView;
  condition:string;
  ngOnInit(): void {
    if ( ObjectUtil.isNotEmpty(this.parentRow)){
      this.condition = `codecontract=${this.parentRow.linha['CODECONTRACT']} and codeproduct=${this.parentRow.linha['CODEPRODUCT']}`
    }
    
  }

}
